/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_CostInputs */

const en_mk_sol_lembaga_cost = /** @type {(inputs: Mk_Sol_Lembaga_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six seats on the Team plan: Rp 594,000 a month. Volunteers who only read can be invited without adding paid seats.`)
};

const id_mk_sol_lembaga_cost = /** @type {(inputs: Mk_Sol_Lembaga_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam kursi paket Tim: Rp 594.000 per bulan. Relawan yang hanya membaca bisa diundang tanpa menambah kursi berbayar.`)
};

/**
* | output |
* | --- |
* | "Six seats on the Team plan: Rp 594,000 a month. Volunteers who only read can be invited without adding paid seats." |
*
* @param {Mk_Sol_Lembaga_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_cost = /** @type {((inputs?: Mk_Sol_Lembaga_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_cost(inputs)
	return en_mk_sol_lembaga_cost(inputs)
});